import React from "react";
import { Controller } from "react-hook-form";
import type { PathArray } from "common/utils/formStructure";
import { Checkbox } from "../../../../../../../Inputs";
import TextareaInput from "../../../../../../../Inputs/Textarea";
import {
  getUiSchemaPropertyFormPath,
  useBuilderFormContext,
  useBuilderWatch,
} from "../../../form/form";
import { FieldWrapper } from "../../__styles__/SidebarColumn";

type GenerativeAIPromptInputProps = {
  fieldPath: PathArray;
  isRequired: boolean;
  isReadOnly?: boolean;
};

export function GenerativeAIPromptInput({
  fieldPath,
  isRequired,
  isReadOnly,
}: GenerativeAIPromptInputProps) {
  const { control } = useBuilderFormContext();
  const useGenerativeAIPropertyFormPath = getUiSchemaPropertyFormPath(
    fieldPath,
    "useGenerativeAI",
  );
  const generativeAIPromptPropertyFormPath = getUiSchemaPropertyFormPath(
    fieldPath,
    "generativeAIPrompt",
  );
  const [useGenerativeAI, generativeAIPrompt] = useBuilderWatch([
    useGenerativeAIPropertyFormPath,
    generativeAIPromptPropertyFormPath,
  ]);

  return (
    <div>
      <FieldWrapper>
        <Controller
          control={control}
          name={useGenerativeAIPropertyFormPath}
          defaultValue={!!generativeAIPrompt}
          render={({ field }) => {
            return (
              <Checkbox
                label="Use AI to complete field"
                value={useGenerativeAI}
                onChange={field.onChange}
                name={field.name}
                // prevent the user from enabling generative AI if the field is
                // required (i.e., if this field is meant to be filled out by
                // the user at creation time)
                disabled={isReadOnly || isRequired}
              />
            );
          }}
        />
      </FieldWrapper>
      <Controller
        control={control}
        name={generativeAIPromptPropertyFormPath}
        render={({ field }) => {
          return (
            <TextareaInput
              value={generativeAIPrompt}
              label="AI prompt"
              name={field.name}
              onChange={field.onChange}
              disabled={!useGenerativeAI || isReadOnly}
            />
          );
        }}
      />
    </div>
  );
}
